<template>
  <div>
    <all-actions v-if="activeModule === 'all-actions'" />
    <transition-maps v-if="activeModule === 'transition-maps'" />
    <transition-review v-if="activeModule === 'transition-review'" />
  </div>
</template>

<script>
export default {
  name: 'Wrapper',
  props: {
    activeModule: {
      type: String,
      required: true
    }
  },
  components: {
    'all-actions': () => import('@/components/transition/actions/Main.vue'),
    'transition-maps': () => import('@/components/transition/maps/Main.vue'),
    'transition-review': () =>
      import('@/components/transition/reviewer/Main.vue')
  }
}
</script>
